import React from 'react';
import { withTranslation } from 'react-i18next';

class TechnicalSpecs extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      selectedTab: 'about_the_watch'
    };
  }

  setSelectedTab = (selectedTab) => {
    this.setState({
      selectedTab: selectedTab
    });
  };

  get tabs_attributes() {
    const { t } = this.props;
    return {
      about_the_watch: {
        title: t('About the watch'),
        attrs: [
          'sku',
          'origin',
          'warranty_tissot',
          'reference_size',
          'krimporter',
          'collection_label',
          'weight',
          'etan_label',
        ]
      },
      case_and_crystal: {
        title: t('Case & crystal'),
        attrs: [
          'shape',
          'boite_label',
          'diameter12h6h',
          'diameter3h9h',
          'lugs',
          'box_height',
          'case_options_label',
          'diamond_case_quantity',
          'diamond_case_colour',
          'diamond_case_clarity',
          'diamond_case_cut',
          'diamond_case_carat',
          'glace_label',
        ]
      },
      movement: {
        title: t('Movement'),
        attrs: [
          'movement_entitled',
          'is_chronometer',
          'movement_web',
          'movement_caliber',
          'movement_diameter',
          // 'sousfamille_tissotmovementcaliber_jewelsmovement',
          'movement_battery',
          'movement_energy',
          'movement_dial',
          'movement_functions_summary',
          'movement_power_reserve',
        ]
      },
      dial: {
        title: t('Dial'),
        attrs: [
          'dial_color_label',
          'dial_type_label',
          'diamond_dial_quantity',
          'diamond_dial_colour',
          'diamond_dial_clarity',
          'diamond_dial_cut',
          'diamond_dial_carat',
        ]
      },
      strap: {
        title: t('Strap'),
        attrs: [
          'bracelet_code',
          'bracelet_color_label',
          'bracelet_brac_text_face',
          'bracelet_brac_text_back',
          'bracelet_brac_color_label',
          'bracelet_options_label',
          'diamond_brac_quantity',
          'diamond_brac_colour',
          'diamond_brac_clarity',
          'diamond_brac_cut',
          'diamond_brac_carat',
          'braceletsxlcode',
          'braceletsxscode',
          'bracelet_links_ref'
        ]
      }
    };
  }

  renderAttributes = (selectedTab, product) => (
    this.tabs_attributes[selectedTab].attrs.map((attr) => {
      const attribute = product.getAttribute(attr);
      if (attribute.value !== false && attribute.value !== null && attribute.value !== "") {
        return (
          <div className="tabs-item" key={attr}>
            <span className="label">{attribute.label}</span>
            {' '}
            { attribute.value !== true && (
              <span className="value">{attribute.value}</span>
            ) }
          </div>
        );
      }
      return null;
    }));

  render() {
    const { selectedTab } = this.state;
    const { product } = this.props;
    const tabs = [];
    for (const tab in this.tabs_attributes) {
      const props = {
        onClick: () => this.setSelectedTab(tab)
      };
      if (tab === selectedTab) props.className = 'active';
      tabs.push(
        <button type="button" key={tab} {...props}>
          {this.tabs_attributes[tab].title}
        </button>
      );
    }

    return (
      <div className="tabs">
        <div className="tabs-menu">
          {tabs}
        </div>
        <div className="tabs-content">
          {this.renderAttributes(selectedTab, product)}
        </div>
      </div>
    )
  }
}

export default withTranslation()(TechnicalSpecs);
